import * as React from 'react';
import { observer } from 'mobx-react';
import { Breakpoints } from 'elc-base-theme';
import { Desktop, Mobile } from 'elc-layouts';
import ProductShadePicker from '../../../exported/product-shade-picker/ProductShadePicker';
import { IShadePickerConfig } from '../../interfaces/IShadePicker';
import { diContainer, serviceNames } from '../../../service-setup/diContainer';

@observer
export class ProductFullShadePicker extends React.Component<IShadePickerConfig> {
    public render() {
        const { isShaded } = this.props;
        const useSidebar = this.props.isButtonModal;
        const sizePickerConfig = {
            ...this.props,
            isCarousel: !useSidebar
        };

        return (
            <>
                <Desktop minWidth={Breakpoints.desktop}>
                    {() =>
                        isShaded && (
                            <ProductShadePicker
                                config={this.props}
                                viewController={diContainer.get(
                                    serviceNames.productShadePickerViewController
                                )}
                            />
                        )
                    }
                </Desktop>
                <Mobile maxWidth={Breakpoints.desktop - 1}>
                    {() =>
                        isShaded && (
                            <ProductShadePicker
                                config={sizePickerConfig}
                                viewController={diContainer.get(
                                    serviceNames.productShadePickerViewController
                                )}
                            />
                        )
                    }
                </Mobile>
            </>
        );
    }
}
